﻿<div class="container-fluid">
  <app-custom-table-title [icon]="icon" [title]="title" [subTitle]="subTitle"></app-custom-table-title>
  <div class="mt-4 mb-4 cf-table-card">

    <ng-template #investmentSummary>
      <div class="total-card">
        <p class="label">{{ hasSelection ? 'Seleccionadas' : 'Inversiones' }} <strong>{{ totals.count }}</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Total <strong>{{ totals.total | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Pagado <strong>{{ totals.paid | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Pendiente <strong>{{ totals.pending | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Valor neto contable <strong>{{ totals.netBook | number:'1.2-2' }} €</strong></p>
      </div>
    </ng-template>

    <ng-template #quickFilter>
      <div class="quick-filter">
        <app-search-filter [value]="quickSearch" placeholder="Buscar descripción, cuenta, importe…" (searchChange)="onSearchChange($event)"></app-search-filter>
      </div>
    </ng-template>

    <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>

    <ng-template #expandDetail let-row>
      <app-financial-investment-detail
        [row]="row"
        [refreshToken]="refreshToken"
        (changed)="reload()"
        (edit)="edit(row)">
      </app-financial-investment-detail>
    </ng-template>
  </div>
</div>
